export const getItemFromLS = (key) => {
  const data = typeof window !== 'undefined' ? localStorage.getItem(key) : ''

  try {
    return data === 'undefined' ? undefined : data ? JSON.parse(data) : data
  } catch {
    return data
  }
}

export const setItemToLS = (key, value) => {
  const stringify = typeof value !== 'string' ? JSON.stringify(value) : value
  return localStorage.setItem(key, stringify)
}

export const removeItemFromLS = (key) => {
  return localStorage.removeItem(key)
}
